import http from "../../http";

const compComment = {
    addCompComment(r) {
        return http.tip.payload("/gateway/api/pc/compComment/addCompComment", r);
    },
    updateCompComment(r) {
        return http.tip.payload("/gateway/api/pc/compComment/updateCompComment", r);
    },
    deleteCompComment(r) {
        return http.confirm.tip.post("/gateway/api/pc/compComment/deleteCompComment", r);
    },
    selectCompComment(r) {
        return http.get("/gateway/api/pc/compComment/selectCompComment", r);
    },
    selectCompCommentPage(r) {
        return http.post("/gateway/api/pc/compComment/selectCompCommentPage", r);
    },
}
export default compComment
